//@ts-nocheck
import { Flex } from "flicket-ui";

import { Footer, Layout, PageContainer } from "~components";
import { Release } from "~graphql/fetchers";
import { EventQuery, MembershipQuery } from "~graphql/sdk";
import { CreateOrderFn, useAccount } from "~hooks";
import { List } from "./non-seated";

type NonSeatedProps = {
  eventOrMembership: EventQuery["event"] | MembershipQuery["membership"];
  zones: any[];
  createOrder: CreateOrderFn;
  isMembership?: boolean;
  isAdmin?: boolean;
  releaseNotes?: string;
  locations?: string;
  isDigital?: boolean;
  allowPublicComp?: boolean;
  addons?:
    | MembershipQuery["membership"]["addons"]
    | Release["releaseEventAddons"][number]["eventAddon"][];
};

export const NonSeated = ({
  addons,
  eventOrMembership,
  zones,
  createOrder,
  isMembership = false,
  isAdmin,
  releaseNotes,
  isDigital,
  allowPublicComp,
}: NonSeatedProps) => {
  const { isPOS } = useAccount();

  const hasFullPageBackground = !!eventOrMembership?.backgroundImageFullPage;

  return (
    <>
      <Flex flexDirection="column" flex={1}>
        <Flex
          flexDirection="column"
          flex={1}
          maxH={{
            _: isAdmin ? "calc(100vh - 96px)" : "calc(100vh - 64px)",
            md: "unset",
          }}
          overflowY={{ _: "auto", md: "visible" }}
        >
          <Layout pt={"0 !important" as any} layoutType="overlay">
            <PageContainer
              backgroundImage={eventOrMembership?.backgroundImage}
              backgroundImageFullPage={
                eventOrMembership?.backgroundImageFullPage
              }
              bannerImage={
                isMembership && !isPOS
                  ? eventOrMembership?.banner
                  : eventOrMembership?.logo
              }
              titleText={eventOrMembership?.description}
              footer={<Footer />}
              title={null}
            >
              <List
                addons={addons}
                eventOrMembership={eventOrMembership}
                zones={zones}
                createOrder={createOrder}
                isMembership={isMembership}
                releaseNotes={releaseNotes}
                isDigital={isDigital}
                allowPublicComp={allowPublicComp}
              />
              {hasFullPageBackground && (
                <Footer hasFullPageBackground={hasFullPageBackground} />
              )}
            </PageContainer>
          </Layout>
        </Flex>
      </Flex>
    </>
  );
};
